import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  return (
    <div className="footer-div">
      <Fade>
       <div className="footer-text">All rights reserved &copy;{greeting.title}  {new Date().getFullYear()}.</div>
      </Fade>
    </div>
  );
}
